import React, { createContext, useEffect, ReactElement, ReactNode, useState, useContext } from 'react';
import { Report } from '@lanterds/types';
import { getReports } from 'src/api/reports';

export interface ReportsContextShape {
    reports: Report[] | null;
    isFetchingReports: boolean;
}

const initialContext: ReportsContextShape = {
    reports: null,
    isFetchingReports: false,
};

const ReportsContext = createContext(initialContext);

export const ReportsContextProvider = ({ children }: { children: ReactElement | ReactNode | ReactNode[] }) => {
    const [reports, setReports] = useState<Report[] | null>(null);
    const [isFetchingReports, setIsFetchingReports] = useState(false);

    useEffect(() => {
        setIsFetchingReports(true);
        getReports()
            .then((reports: Report[]) => {
                setReports(reports);
            })
            .finally(() => {
                setIsFetchingReports(false);
            });
    }, []);

    return <ReportsContext.Provider value={{ reports, isFetchingReports }}>{children}</ReportsContext.Provider>;
};

export const useReportsContext = () => useContext(ReportsContext);
